import styles from "@/elements-react/product-element-refactor/product-element.module.scss";
import React from "preact/compat";
import classNames from "classnames";

interface ProductElementLinkWrapperProps {
  className?: string;
  children: React.ReactNode;
  href: string;
  productId: string;
  onClick?: () => void;
}

export const ProductElementLinkWrapper: React.FC<ProductElementLinkWrapperProps> = ({ children, href, productId, onClick = undefined, className = "" }) => {
  return (
    <a className={classNames(styles["link-wrapper"], className)} href={href} draggable={false} data-product-id={productId} onClick={onClick}>
      {children}
    </a>
  );
};
